<template>
<div class="chapter">
<div class="inner_page">
<p class="image5c"><a id="page_10"><img alt="Image" height="327" src="images/6.jpg" width="300"/></a></p><a id="page_10">
<p class="noindent">Budgeting allows you to control your money rather than money controlling you. The goal of budgeting is to spend <span class="txit">less</span> money than you make and to decide in advance where your money is going.</p>
<p class="h3">Basic budget worksheet</p>
<p class="h4">Monthly income: ____________</p>
<p class="h4">Monthly expenses</p>
<p class="noindent"><span class="txit">Fixed expenses (expenses that stay the same every month)</span></p>
<p class="indent">Tithe/charitable giving ____________</p>
<p class="indent">Utilities ____________</p>
</a><p class="indent"><a id="page_10"></a><a id="page_11">Insurance ____________</a></p><a id="page_11">
<p class="indent">Car loan ____________</p>
<p class="indent">Student loans ____________</p>
<p class="indent">Phone bill ____________</p>
<p class="indent">Internet service ____________</p>
<p class="indent">Other payments ____________</p>
<p class="indent"><span class="txit">Tot</span>al fi<span class="txit">xed expenses ____________</span></p>
<p class="indent"> </p>
<p class="noindent">A. Monthly income __________ – Fixed expenses __________ = The amount you can spend on your variable expenses __________</p>
<p class="noindent1"><span class="txit">Variable expenses (expenses the amounts of which can change from month to month)</span></p>
<p class="indent"> </p>
<p class="noindent">Groceries ___________________________________________</p>
<p class="noindent">Household items (stamps, light bulbs, plants, etc.) _____________</p><p class="noindent">Personal items (toiletries, dry cleaning, haircuts, etc.) __________</p>
<p class="noindent">Transportation (gas, parking, bus pass, auto maintenance, etc.)<br/>__________________________________________________</p>
<p class="noindent">Clothing ___________________________________________</p>
<p class="noindent">Savings ___________________________________________</p>
<p class="noindent">Entertainment (cable, movies, eating out) ___________________</p>
<p class="noindent">Other _____________________________________________</p>
<p class="noindent"><span class="txit">Total variable expenses _______________________________</span></p>
<p class="indent"> </p>
<p class="noindent">B. Amount from Line A ____________ – Total variable expenses____________ = ____________</p>
<p class="indent"> </p>
</a><div class="sidebar"><a id="page_11">
</a><p class="sidebartit"><a id="page_11"></a><a id="page_12">Budgeting resources</a></p><a id="page_12">
</a><p class="indenthanging"><a id="page_12">• Dave Ramsey, money management expert (</a><a class="nounder" href="http://www.daveramsey.com" target="_blank">www.daveramsey.com</a>)</p>
<p class="indenthanging">• Crown Financial Ministries (<a class="nounder" href="http://www.crown.com" target="_blank">www.crown.org</a>)</p>
</div>
<p class="indent"> </p>
<p class="noindent">Take your total variable expenses and subtract them from total on line A. The answer must be greater than zero! If the answer is a negative number, reduce your budgeted numbers, starting with the variable expenses first.</p>
<p class="indent">WARNING—Do not adjust groceries and clothing to zero. You have to eat and have clothes on your back . . . you just don’t have to eat sushi and wear designer clothing.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?1d6e28d0